var _ellipse, _rect, _rect2, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _ellipse2, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineEmptyResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 224,
    viewBox: "0 0 260 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.598,
    cy: 112,
    rx: 114.048,
    ry: 111.319,
    fill: "#CADDFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.5362,
    height: 2.5673,
    rx: 1.28365,
    transform: "matrix(-0.989469 -0.144748 -0.144748 0.989469 120.914 112.268)",
    fill: "#1778E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15.5362,
    height: 2.5673,
    rx: 1.28365,
    transform: "matrix(-0.989736 0.142905 0.142905 0.989736 93.1777 110.02)",
    fill: "#1778E1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.88104,
    cy: 2.88104,
    r: 2.88104,
    transform: "matrix(-1 0 0 1 113.71 120.103)",
    fill: "#1778E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.88104,
    cy: 2.88104,
    r: 2.88104,
    transform: "matrix(-1 0 0 1 90.6626 120.103)",
    fill: "#1778E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.129 124.425L103.953 130.508C104.561 131.474 104.238 132.755 103.193 133.213C100.928 134.208 97.9214 135.086 96.4253 134.028",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9404 145.186C92.8158 142.796 98.6097 138.603 106.783 140.941",
    stroke: "#1778E1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.617 93.9158C130.844 115.176 128.617 150.408 117.683 161.342C106.515 172.51 87.3103 169.847 76.3763 166.809C65.4422 163.772 59.9757 158.913 55.1161 148.586C50.2565 138.259 47.2175 146.873 39.322 138.259C32.6405 130.97 32.0331 126.11 36.2848 116.391C40.1342 107.592 53.9007 106.672 58.1529 123.073",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.185 93.5692C123.111 98.6312 106.143 108.13 89.134 104.242C72.1255 100.355 61.053 115.986 58.0158 123.681C56.3959 117.809 52.876 110.924 44.1829 110.924C38.7157 110.924 34.0588 119.834 33.8563 122.466C22.3148 120.036 6.521 110.924 25.9595 88.4488C50.6857 59.8594 87.0478 73.8899 100.068 59.2914C120.114 36.8158 158.383 45.9275 153.523 75.085C148.664 104.242 185.718 129.148 166.887 156.483C151.823 178.351 154.131 191.512 157.168 195.36",
    stroke: "#1778E1",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.326 77.2346L179.751 59.6389L195.324 73.506L173.326 77.2346Z",
    fill: "#1778E1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.889,
    cy: 46.1475,
    rx: 41.127,
    ry: 33.1902,
    transform: "rotate(4.41637 215.889 46.1475)",
    fill: "#1778E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.901,
    cy: 45.9207,
    r: 4.68992,
    transform: "rotate(4.41637 198.901 45.9207)",
    fill: "#F2F7FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.333,
    cy: 45.0962,
    r: 4.68992,
    transform: "rotate(4.41637 216.333 45.0962)",
    fill: "#F2F7FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.764,
    cy: 44.2715,
    r: 4.68992,
    transform: "rotate(4.41637 233.764 44.2715)",
    fill: "#F2F7FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineEmptyResult);
export default __webpack_public_path__ + "static/media/outline-empty-result.29b4d7b5.svg";
export { ForwardRef as ReactComponent };